// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"73e7e364","419":"f132e4af","563":"d54d9428","787":"62e70764","942":"a06cccac"}[chunkId] + ".chunk.js";
};